import "./KTrucksMapSidebar.scss";
import Sidebar from "../mixins/sidebar";
import { KDataTable } from "kinnect-general";
import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { faTachometerAlt } from "@fortawesome/free-solid-svg-icons";
import { formatTime } from "kinnect-formatters";
import { sortByKey } from "kinnect-helpers";
import {
	VBtn,
	VCheckbox,
	VCol,
	VDivider,
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle,
	VMenu,
	VSpacer,
	VSubheader,
	VToolbar,
	VToolbarTitle,
	VListItemGroup
} from "vuetify/lib";

library.add( faTachometerAlt );
dom.watch();

export default {
	name: "KTrucksMapAlertsSidebar",

	inject: [ "storeModuleName" ],

	mixins: [ Sidebar ],

	props: {
		alerts: {
			default: () => [],
			type: Array
		}
	},

	data: () => ( {
		headers: [
			{
				sortable: false,
				text: "",
				value: "alertType"
			},
			{
				text: "Time",
				value: "alertDateTime"
			},
			{
				sortable: false,
				text: "Desc.",
				value: "alertDesc"
			}
		],

		statusMap: {
			HARSH_BRAKING: {
				color: "yellow lighten-1",
				icon: "warning",
				label: "Harsh Braking"
			},
			IDLE_START: {
				color: "grey darken-1",
				icon: "hourglass_full",
				label: "Idle Start"
			},
			IDLE_END: {
				color: "grey darken-1",
				icon: "hourglass_full",
				label: "Idle End"
			},
			SPEEDING: {
				color: "orange darken-3",
				icon: "fas fa-tachometer-alt",
				label: "Speeding"
			},
			HIGH_SPEED: {
				color: "red darken-4",
				icon: "fas fa-tachometer-alt",
				label: "High Speed"
			},
			RAPID_ACCELERATION: {
				color: "amber lighten-1",
				icon: "flash_on",
				label: "Rapid Acceleration"
			},
			POWER_ON: {
				color: "green darken-3",
				icon: "power",
				label: "Power On"
			},
			FIRST_IGNITION_OF_DAY: {
				color: "green darken-3",
				icon: "vpn_key",
				label: "First Ignition of Day"
			},
			NO_SIGNAL: {
				color: "grey darken-3",
				icon: "signal_wifi_off",
				label: "No GPS Signal"
			}
		},

		selectedFilters: []
	} ),

	computed: {
		show: {
			get() {
				return this.$store.state[this.storeModuleName].alerts;
			},
			set( value ) {
				this.$store.dispatch( `${this.storeModuleName}/setAlerts`, value );
			}
		},

		statusTypes() {
			return Object.keys( this.statusMap );
		},

		filterItems() {
			const items = Object.keys( this.statusMap ).map( status => ( {
				text: this.statusMap[status].label,
				value: status
			} ) );

			return sortByKey( items, "text" );
		},

		filteredAlerts() {
			return this.alerts.filter( alert => this.selectedFilters.indexOf( alert.alertCode ) !== -1 );
		},

		alertFilterList() {
			return this.filterItems.map( item =>
				<VListItem
					key={item.value}
					scopedSlots={{
						default: ( { active, toggle } ) => [
							<VListItemAction>
								<VCheckbox
									color="accent"
									inputValue={active}
									onClick={toggle}
									truValue={item.value}
								></VCheckbox>
							</VListItemAction>,

							<VListItemContent>
								<VListItemTitle>{item.text}</VListItemTitle>
							</VListItemContent>
						]
					}}
					value={item.value}
				></VListItem>
			);
		},

		noDataMessage() {
			if ( !this.alerts.length ) {
				return "No alerts to display";
			} else if ( this.alerts.length && !this.filteredAlerts.length ) {
				return "There are no alerts matching the selected filters";
			}
		}
	},

	watch: {
		show() {
			this.$nextTick( () => this.$gmapDefaultResizeBus.$emit( "resize" ) );
		}
	},

	created() {
		this.selectedFilters = this.statusTypes.slice();
	},

	render() {
		if ( !this.show ) {
			return;
		}

		return <VCol class={[
			this.sidebarClasses,
			"pl-0"
		]}>
			<VToolbar flat class="transparent">
				<VToolbarTitle>Alerts</VToolbarTitle>
				<VSpacer></VSpacer>
				<VBtn icon onClick={() => this.show = false}>
					<VIcon>close</VIcon>
				</VBtn>
			</VToolbar>

			<VDivider></VDivider>

			<KDataTable
				dense
				headers={this.headers}
				headersLength={this.headers.length + 1}
				hideDefaultFooter
				items={this.filteredAlerts}
				itemsPerPage={-1}
				loading={this.loading}
				noDataText={this.noDataMessage}
				selectAll
				sortBy="alertDateTime"
				sortDesc
				scopedSlots={{
					"header.alertType": () =>
						<VMenu
							closeOnContentClick={false}
							left
							offsetX
							offsetY
							scopedSlots={{
								activator: ( { on } ) =>
									<VBtn
										class="my-1"
										icon
										on={on}
										outlined
									><VIcon>filter_list</VIcon></VBtn>
							}}
						>
							<VList subheader>
								<VSubheader>Filter Alerts</VSubheader>
								<VListItemGroup
									multiple
									vModel={this.selectedFilters}
								>
									{this.alertFilterList}
								</VListItemGroup>
							</VList>
						</VMenu>,

					item: ( { item } ) =>
						<tr key={`${item.alertDateTime}-${item.alertCode}`}>
							<td class={`${this.statusMap[item.alertCode].color} text-center`}>
								<VIcon>{this.statusMap[item.alertCode].icon}</VIcon>
							</td>
							<td class="text-no-wrap">{formatTime( item.alertDateTime )}</td>
							<td>{item.alertDesc}</td>
						</tr>
				} }
			></KDataTable>
		</VCol>;
	}
};
